export default __webpack_public_path__ + "static/media/Canutillo.f6dc57ef.jpg";